import { SortDirection } from '@angular/material/sort';

export enum TableNameType {
  EXPIRING_DOCUMENT_TABLE = 'Expiring Document Table',
  ONGOING_DUE_DILIGENCE_TABLE = 'Ongong Due Diligence Table',
  PENDING_TASK_TABLE = 'Pending Task Table',
  OVERDUE_TASK_TABLE = 'Overdue Task Table'
}

export enum TablePreferenceType {
  PAGE_SIZE = 'pageSize',
  SORT = 'sort'
}

export interface TablePreference {
  pageSize?: number;
  sort?: TableSortPreference;
}

export interface TableSortPreference {
  active: string;
  direction: SortDirection;
}

export interface TablesPreference {
  [tableName: string]: TablePreference;
}
